import { ProductCard } from "components/ui";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Grid } from "@mui/material";
import RemoveProduct from "components/ui/RemoveModal/RemoveModal";
import { useLocation, useNavigate } from "react-router-dom";
// import productData from "db/productsData.json";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import { useGlobalContext } from "context/GlobalContext";
import { transformData, transformDataForCatalogDataPage, transformDataForTrayModal } from "utils/transformdata";
import { useGetSingleCataloProducts } from "../hooks/useGetSingleCatalogProducts";
import { useInView } from "react-intersection-observer";
import CatalogueCardSkeleton from "./CatalogueCardSkeleton";
import SortContext from "context/SortContext";
import { debounce } from "lodash";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, hasAccessPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import GoToTop from "components/ui/GoToTop";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import apiClient from "lib/api-client";
import InfoModal from "components/ui/InfoModal/InfoModal";
import CatalogueHookProduct from "./CatalogueHookProduct";
import { useFilter } from "context/FilterContext";
import config from "configs/config";
import { useSelector } from "react-redux";
import SetBasedView from "./SetView";
import CategoryView from "./CategoryView";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function CatalogueProducts({ catalogueId }) {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  const isEdit = state && state.edit ? state.edit : false;
  const newName = state && state.newName ? state.newName : "";
  const catalogueDisplayName =
    state?.catalogueName ||
    (Array.isArray(state?.name) ? state.name[0] : state?.name) ||
    newName ||
    "";

  const innerChnages = state && state?.innerChnages ? state?.innerChnages : false;
  const [removeProductModal, setRemoveProductModal] = useState(false);
  const [removeProductInfo, setRemoveProductInfo] = useState({});
  const [sliderLoading, setSliderLoading] = useState(true);
  const [catalogueData, setCatalogueData] = useState([]);

  const catalogProductsPresence = useMemo(
    () => ({
      styleNumbers: (catalogueData || []).map((p) => p.styleNumber).filter(Boolean),
      designIds: (catalogueData || []).map((p) => String(p._id || p.id)).filter(Boolean),
    }),
    [catalogueData]
  );
  const { search, setSearch, sortOptions, selectedSortValue, setSortOptions, setSelectedSortValue } = React.useContext(SortContext);
  const { setFilter, setFilterValues, filterValues, backendFilterValues, setBackendFilterValues, appliedFilterValues, setAppliedFilterValues, setFilterCount } = useFilter();
  const sort = sortOptions.find((item) => item.id == selectedSortValue);

  const cartData = useSelector((state) => state.cart.cartData);

  const {
    setCreateBtn,
    setCreateBtnName,
    setCreateBtnOption,
    setRemoveIcon,
    trashModalOpen,
    setTrashModalOpen,
    setIsArchiveBtn,
    setIsInfoBtn,
    infoModalOpen,
    setInfoModalOpen,
    setSearchResultCount,
    setDisplayCount,
    setSearchPlaceHolder,
    // cartData,
    catalogData,
    setFilterChangeCount,
    setCatalogData,
    setShowActivityLogo,
    checkedItems,
    setCheckedItems,
    activeCatalogView,
    setActiveCatalogView,
  } = useGlobalContext();
  // const [checkedItems, setCheckedItems] = useState([]);
  const [isPagination, setIsPagination] = useState(false);
  const { ref, inView } = useInView({
    threshold: 1.0,
  });
  const permission = usePermissions();

  const removeLimit = useMemo(()=> activeCatalogView !== "mixView",[activeCatalogView])

  const {
    data: newData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    error,
  } = useGetSingleCataloProducts({
    catalogId: catalogueId,
    limit: isEdit ? (JSON.parse(sessionStorage.getItem("countLimit") || "null") ?? 10) : removeLimit ? 1000 : 10,
    search: search || "",
    sortBy: sort?.sortBy || "",
    order: sort?.order || "",
    filterBy: filterValues || {},
    isHidden: !filterValues?.["Show Hidden Designs"],
  });

  const fetchedCatalogueData = (data) => {
    if (data) {
      return data?.pages
        .map((page) => {
          return page?.catalogProducts.map((product) => product);
        })
        .flat();
    }
    return [];
  };
  const getCatalogueData = useCallback(() => {
    const updateProductsData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
    if (isEdit && updateProductsData?.length > 0) {
      if (isPagination) {
        const catalogData = JSON.parse(sessionStorage.getItem("catalogWithProduct")) || {};
        let existingItemCatalogProduct = catalogData.productData || [];
        let newDataProduct = fetchedCatalogueData(newData);
        let findNewEntrysData = newDataProduct.filter((newItem) => {
          return !existingItemCatalogProduct.some((existingItem) => existingItem._id === newItem._id);
        });
        catalogData.productData = newDataProduct;
        sessionStorage.setItem("catalogWithProduct", JSON.stringify(catalogData));
        let newUpdateProductData = [...updateProductsData, ...findNewEntrysData];
        sessionStorage.setItem("updateProductsData", JSON.stringify(newUpdateProductData));
        setCatalogueData(newUpdateProductData);
      } else {
        setCatalogueData(updateProductsData);
      }
    } else if (newName === "Create Order") {
      setCatalogueData(fetchedCatalogueData(newData));
      const catalogData = JSON.parse(sessionStorage.getItem("catalogWithProduct")) || {};
      catalogData.productData = fetchedCatalogueData(newData);
      sessionStorage.setItem("catalogWithProduct", JSON.stringify(catalogData));
    } else {
      setCatalogueData(fetchedCatalogueData(newData));
      const catalogData = JSON.parse(sessionStorage.getItem("catalogWithProduct")) || {};
      catalogData.productData = fetchedCatalogueData(newData);
      sessionStorage.setItem("catalogWithProduct", JSON.stringify(catalogData));
      sessionStorage.setItem("updateProductsData", JSON.stringify(fetchedCatalogueData(newData)));
    }

    setFilterChangeCount(newData?.pages[0]?.totalDesigns);
  }, [newData, isEdit, isPagination]);

  const removeCart = (element) => {
    setRemoveProductInfo(element);
    setRemoveProductModal(true);
  };

  const btnInfo = [
    {
      btnName: "Remove",
      bgColor: "#E77B7B",
      click: () => {
        // const findRemoveProductIds =checkedItems;
        const newCatalogueData = catalogueData.filter((curElemt) => !checkedItems.includes(String(curElemt._id || curElemt.id)));
        setCatalogueData(newCatalogueData);
        sessionStorage.setItem("updateProductsData", JSON.stringify(newCatalogueData));
        setTrashModalOpen(false);
        setCheckedItems({});
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setTrashModalOpen(false),
    },
  ];
  const handleCheckboxChange = (itemId) => (event) => {
    setCheckedItems((prevCheckedItems) => {
      let newCheckedItems;

      if (event.target.checked) {
        newCheckedItems = prevCheckedItems.includes(itemId) ? prevCheckedItems : [...prevCheckedItems, itemId];
      } else {
        newCheckedItems = prevCheckedItems.filter((id) => id !== itemId);
      }

      sessionStorage.setItem("checkedItems", JSON.stringify(newCheckedItems));
      return newCheckedItems;
    });
  };

  const debouncedFetchNextPage = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  useEffect(() => {
    if (inView) {
      debouncedFetchNextPage(); // Call the debounced function directly
      setIsPagination(true);
    }
  }, [inView, debouncedFetchNextPage, isPagination]);

  //  useEffect(() => {
  //    if (inView && !isEdit) {
  //      debouncedFetchNextPage(); // Call the debounced function directly
  //      setIsPagination(true);
  //    } else if (isEdit && hasNextPage) {
  //      debouncedFetchNextPage();
  //      setIsPagination(true);
  //    }
  //  }, [inView, debouncedFetchNextPage, isPagination]);

  useEffect(() => {
    setSearchResultCount(newData?.pages[0]?.totalDesigns);
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setDisplayCount(false);
    };
  }, [newData]);

  useEffect(() => {
    if (checkedItems?.length > 0) {
      setRemoveIcon(true);
    } else {
      setRemoveIcon(false);
    }
    return () => setRemoveIcon(false);
  }, [checkedItems]);

  useEffect(() => {
    if (!isEdit) {
      setCreateBtn(isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "view"));
      setCreateBtnName("Add Design");
      setCreateBtnOption([
        // { option: "By Category", link: "/Category", view: hasAccessPage(findSpecificPage("Category", permission), "view") },
        { option: "By Category", link: "/Category", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Category Access"), "view") },
        // { option: "By Collection", link: "/Collection", view: hasAccessPage(findSpecificPage("Collection", permission), "view") },
        { option: "By Collection", link: "/Collection", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "view") },
        // { option: "By Set", link: "/Sets", view: hasAccessPage(findSpecificPage("Sets", permission), "view") },
        { option: "By Set", link: "/Sets", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "view") },
        // { option: "By Stock", link: "/Stock", view: hasAccessPage(findSpecificPage("Stock", permission), "view") },
        { option: "By Stock", link: "/Stock", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Stocks Access"), "view") },
      ]);

      setIsArchiveBtn(hasAccessPage(findSpecificPage("Catalog", permission), "archive"));

      return () => {
        setCreateBtn(false);
        setCreateBtnName("");
        setCreateBtnOption([]);
        setIsArchiveBtn(false);
      };
    }
  }, [isEdit]);

  // useEffect(() => {
  //   getCatalogueData();
  // }, [isEdit]);

  // useEffect(() => {
  //   if (newData) {
  //     getCatalogueData();
  //   }
  // }, [newData]);

  useEffect(() => {
    getCatalogueData();
  }, [newData, isEdit, getCatalogueData]);

  useEffect(() => {
    return () => {
      setActiveCatalogView("mixView");
    };
  }, [setActiveCatalogView]);

  useEffect(() => {
    setSearchPlaceHolder("Search By Design Number");
    setIsInfoBtn(true);
    setSearch("");
    if (!location?.state?.newName) {
      setShowActivityLogo(true);
    }
    // This condition run when User copy Paste URL or Share URL
    if (!location?.state?.name) {
      const params = new URLSearchParams(location.search);
      const decocatalogNumberAndCount = decodeURIComponent(params.get("catalogNumberAndCount") || "");

      //when user copied edit catalog URL
      const decocatalogNumberAndName = decodeURIComponent(params.get("catalogNumberAndName") || "");
      let state;

      if (location?.state?.newName === "Create Order") {
        state = {
          ...location?.state,
          name: [decocatalogNumberAndCount || decocatalogNumberAndName],
        };
      } else {
        state = {
          view: true,
          name: [decocatalogNumberAndCount || decocatalogNumberAndName],
        };
      }

      navigate(`${location?.pathname}${location?.search}`, { state: state, replace: true });
    }

    return () => {
      setSearchPlaceHolder("");
      setSearch("");
      setShowActivityLogo(false);
      setIsInfoBtn(false);
    };
  }, []);

  useEffect(() => {
    setFilter(true);
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      { id: 9, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: true },
      { id: 10, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: true },
      { id: 11, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
      { id: 12, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
    ]);

    const fetchFilterData = async () => {
      try {
        const response = await apiClient.post(`${config?.baseUrl}/api/v1/collection/getDesignSlidersData`, {
          catalogueId: catalogueId,
        });

        if (response?.status === 200) {
          setSliderLoading(false);
          const { diamondPieces, diamondWeight, grossWeight, netWeight, ratio } = response.data.data;
          let filterData = {
            "Ratio": ratio || [0, 100],
            "Diamond Pieces": diamondPieces || [0, 100],
            "Diamond Weight": diamondWeight || [0, 100],
            "Gold Gross-Weight": grossWeight || [0, 100],
            "Gold Net-Weight": netWeight || [0, 100],
            "Design In Collection": ["All"],
            "Design In Sets": ["All"],
            "Best Seller Design": ["All"],
            // "Stock status": ["All"],
            "Product Page Stock Status": ["All"],
            "Highest Seller": ["Gold", "Silver", "Bronze"],
            Labour: ["R", "X", "X2", "X5", "X8", "XX"],
            Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
            "Design Create Date": [],
            "Show Hidden Designs":false,
          };
          let backendOptions = { ...filterData };
          delete backendOptions["Design In Collection"];
          delete backendOptions["Design In Sets"];
          delete backendOptions["Product Page Stock Status"];
          // Update the state with the fetched data
          setBackendFilterValues(backendOptions);
          setFilterValues(filterData);

          if (sessionStorage.getItem("filterChangeCount") == 0) {
            setFilterValues(filterData);
          } else {
            setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    fetchFilterData();
    return () => {
      setFilter(false);
      setFilterValues({
        "Diamond Pieces": [],
        "Diamond Weight": [],
        "Gold Gross-Weight": [],
        "Gold Net-Weight": [],
        "Design In Collection": [],
        "Design In Sets": [],
        "Best Seller Design": [],
        "Stock status": [],
        "Highest Seller": [],
        "Show Hidden Designs":false,
        Labour: [],
        Class: [],
      });
      setFilterCount(0);
      setAppliedFilterValues({});
      setSortOptions([]);
      setSelectedSortValue(null);
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    if (location?.state?.newName !== "Create Order") return;
    const checkIfAllAdded = async () => {
      try {
        const catalogId = location.pathname?.split("/Catalog/")[1];
        if (!catalogId) return;

        // const response = await apiClient.post(`/api/v1/catalog/getDesignsByCatalogId`, { catalogId });
        // const designs = response?.data?.designs;
        const response = await apiClient.post(`/api/v1/catalog/addAllCatalogDesign`, { catalogId });
        const designs = response?.data?.data;
        if (!Array.isArray(designs)) return;
        setCatalogData(designs);
      } catch (error) {
        console.error("Error checking cart status:", error);
      }
    };

    checkIfAllAdded();
  }, []);

  const hasNoResults =
    search &&
    !isLoading &&
    newData?.pages?.every((page) => !page?.catalogProducts?.length);

  if (isLoading || sliderLoading) return <ProductSkeleton count={10} />;
  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;
  if (catalogueData.length === 0) return <ProductSkeleton count={10} />;

  const fetchData = () => apiClient.get(`/api/v1/catalog/getCatalogInfo/${catalogueId}`);

  return (
    <>
      {catalogueData && catalogueData.length > 0 ? (
        <>
          {activeCatalogView === "mixView" && (
            <Grid
              container
              className="Grid-padding"
              direction="row"
              justifyContent="flex-start"
              sx={{
                flex: "1 1 1",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "32px",
                rowGap: "32px",
              }}
            >
              {catalogueData.map((design, index) => {
                let curElement = transformDataForCatalogDataPage(design);
                return (
                  <Grid item className="product" key={`${index}-${curElement?.id}`}>
                    <CatalogueHookProduct
                      design={curElement}
                      index={`${index}-${curElement?.id}`}
                      innerChnages={innerChnages}
                      isEdit={isEdit}
                      checkedItems={checkedItems}
                      handleCheckboxChange={handleCheckboxChange}
                      cartData={cartData}
                      allData={catalogueData}
                    />
                  </Grid>
                );
              })}
              {isFetchingNextPage && <ProductSkeleton count={40} />}
              <div ref={ref} />
            </Grid>
          )}

          {activeCatalogView === "CategoryView" && (
            <div style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}>
              <CategoryView
                allData={catalogueData.map((design) => transformDataForCatalogDataPage(design))}
                innerChnages={innerChnages}
                isEdit={isEdit}
                checkedItems={checkedItems}
                handleCheckboxChange={handleCheckboxChange}
                cartData={cartData}
              />
              {isFetchingNextPage && <ProductSkeleton count={40} />}
              <div ref={ref} />
            </div>
          )}

          {activeCatalogView === "setView" && (
            <div style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}>
              <SetBasedView
                allData={catalogueData.map((design) => transformDataForCatalogDataPage(design))}
                innerChnages={innerChnages}
                isEdit={isEdit}
                checkedItems={checkedItems}
                handleCheckboxChange={handleCheckboxChange}
                cartData={cartData}
                catalogId={catalogueId}
                catalogueName={catalogueDisplayName}
                catalogProductsPresence={catalogProductsPresence}
              />
              {isFetchingNextPage && <ProductSkeleton count={40} />}
              <div ref={ref} />
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            margin: "auto",
            padding: "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <Background />
        </div>
      )}
      <GoToTop />
      <RemoveProduct open={trashModalOpen} setOpen={setTrashModalOpen} btnInfo={btnInfo} heading="Do you want to remove the Design?" removeInfo={removeProductInfo} />
      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} fetchData={fetchData} title="Catalog Details" />
    </>
  );
}

export default CatalogueProducts;